module.exports = __webpack_public_path__ + "static/img/qyh-logo.ca3e9c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/qyh-logo.jpg
// module id = LIBE
// module chunks = 29